import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@quebon/ui/components/dialog'
import completionPopper from '@/assets/learner/completion-popper.svg'
import { Button } from '@/components/learner/ui/Button'

interface LibraryQuizCompletionDialogProps {
  open: boolean
  pending: boolean
  onComplete: () => void
  onKeepProgress: () => void
}

export function LibraryQuizCompletionDialog({
  open,
  pending,
  onComplete,
  onKeepProgress,
}: LibraryQuizCompletionDialogProps) {
  const { t } = useTranslation('learner')

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && !pending) onKeepProgress()
      }}
    >
      <DialogContent
        showCloseButton={false}
        overlayClassName="bg-black/20 backdrop-blur-none"
        className="flex max-w-[360px] flex-col items-center gap-6 rounded-3xl border-0 bg-lc-bg-primary px-6 pb-6 pt-8 text-center shadow-[0_8px_8px_rgba(0,0,0,0.10)] ring-0 sm:max-w-[360px]"
      >
        <div className="flex size-20 items-center justify-center rounded-full bg-lc-key-50">
          <img src={completionPopper} alt="" className="size-10" />
        </div>

        <div className="flex w-full flex-col gap-4">
          <DialogTitle className="text-lc-v3-h4 font-bold leading-[1.45] tracking-[-0.1px] text-lc-text-primary">
            {t('library.quizCompletion.title')}
          </DialogTitle>
          <DialogDescription className="text-lc-v3-body-1 font-normal leading-[1.6] text-lc-text-secondary">
            {t('library.quizCompletion.description')}
          </DialogDescription>
        </div>

        <div className="flex items-center justify-center gap-4">
          <Button
            variant="primary"
            size="L"
            className="min-w-[120px]"
            disabled={pending}
            onClick={onComplete}
          >
            {t('library.quizCompletion.complete')}
          </Button>
          <Button
            variant="neutral"
            size="L"
            className="min-w-[120px]"
            disabled={pending}
            onClick={onKeepProgress}
          >
            {t('library.quizCompletion.keepProgress')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
